import { Button } from '@/components/Button'
import {
  Section,
  SectionItem,
} from '@/features/jobs/info-gathering/components/Section'
import { PhysicalAddressSectionItems } from '@/features/jobs/info-gathering/components/PhysicalAddressSectionItems'
import { type PhysicalAddress } from '@/features/jobs/info-gathering/PhysicalAddress'
import { ContactInfoSectionItems } from '@/features/jobs/info-gathering/components/ContactInfoSectionItems'
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateTitle,
} from '@/components/EmptyState'

export interface PersonalProfileProps {
  hasProfile: boolean
  isLoading: boolean
  isEditable: boolean
  onEdit?: () => void
  fullName?: string
  dateOfBirth?: string
  occupation?: string
  personalTaxpayerIdentificationNumber?: string
  maskedPersonalTaxpayerIdentificationNumber?: string
  phoneNumber?: string
  email?: string
  address?: PhysicalAddress
  emptyStateActionTestId?: string
  editButtonTestId?: string
}

export function PersonalProfile({
  hasProfile,
  isLoading,
  isEditable,
  onEdit,
  fullName,
  dateOfBirth,
  occupation,
  personalTaxpayerIdentificationNumber,
  maskedPersonalTaxpayerIdentificationNumber,
  phoneNumber,
  email,
  address,
  emptyStateActionTestId,
  editButtonTestId,
}: PersonalProfileProps) {
  return (
    <>
      {!hasProfile && (
        <EmptyState size="section">
          <EmptyStateTitle>No general info yet</EmptyStateTitle>
          <EmptyStateDescription>
            Fill in the client's details on their behalf.
          </EmptyStateDescription>
          {isEditable && (
            <EmptyStateActions>
              <Button
                label="Fill in general info"
                variant="text"
                onPress={onEdit}
                testId={emptyStateActionTestId}
              />
            </EmptyStateActions>
          )}
        </EmptyState>
      )}
      {hasProfile && (
        <>
          <Section
            title="Personal Information"
            isLoading={isLoading}
            actions={
              isEditable ? (
                <Button
                  label="Edit"
                  variant="text"
                  onPress={onEdit}
                  testId={editButtonTestId}
                />
              ) : undefined
            }
          >
            <SectionItem label="Name" value={fullName} />

            <SectionItem
              label="Date of birth"
              value={dateOfBirth}
              isSensitive
            />

            <SectionItem label="Occupation" value={occupation} isSensitive />

            <SectionItem
              label="SSN or ITIN"
              value={personalTaxpayerIdentificationNumber}
              maskedValue={maskedPersonalTaxpayerIdentificationNumber}
              isSensitive
            />
          </Section>

          <Section title="Contact Information" isLoading={isLoading} bordered>
            <ContactInfoSectionItems phoneNumber={phoneNumber} email={email} />
            <PhysicalAddressSectionItems address={address} />
          </Section>
        </>
      )}
    </>
  )
}
